<script lang="ts">
    import {
        FeedPostsQueryDocument,
        NewsFeedPostFragmentDoc,
        type ParticipantInput,
    } from '$gql/graphql';
    import { query } from '$lib/apollo/SvelteApollo';
    import { useFragment } from '$gql';
    import FeedPostLoader from '$components/Feed/FeedPostLoader.svelte';
    import FeedPost from '$components/Feed/FeedPost.svelte';
    import uniqBy from 'lodash/uniqBy';
    import { fetchMore } from '$lib/utils/interractions.js';

    export let author: ParticipantInput;
    export let title: string | null = null;
    export let maxPerPage = 5;
    export let withButton = false;
    export let buttonLabel: string | null = null;

    export let titleId: string | null = null;

    export let usePagination = false;

    export let fullPageUrl: string | null = null;

    const { result, fetchMore: loadMore } = query(FeedPostsQueryDocument, {
        variables: {
            author,
            page: 1,
            maxPerPage,
        },
    });

    $: posts = useFragment(NewsFeedPostFragmentDoc, $result.data?.posts.results ?? []);
    $: pagerInfo = $result.data?.posts.pagerInfo;
    $: currentPage = pagerInfo?.page ?? 1;
    $: nbPages = pagerInfo?.nbPages ?? 0;
    $: loading = $result.loading;
    $: nbResults = pagerInfo?.total ?? 0;

    function loadMorePosts() {
        if (!usePagination) return;
        if (loading || currentPage >= nbPages) return;
        loadMore({
            variables: { page: currentPage + 1, maxPerPage },
            updateQuery: (previousQueryResult, { fetchMoreResult }) => {
                let results = [
                    ...previousQueryResult.posts.results,
                    ...fetchMoreResult.posts.results,
                ];
                results = uniqBy(results, 'id');
                fetchMoreResult.posts.results = results;
                return fetchMoreResult;
            },
        });
    }
</script>

<div class={'my-5'}>
    {#if title}
        <h3
            id={titleId}
            class="text-brand-blue_ text-gray-500 font-bold text-16 ls:text-20 m-0 flex-1 my-8 mx-6 t:mx-0"
        >
            {#if fullPageUrl}
                <a href={fullPageUrl} class={'text-gray-500 cursor-pointer'}>
                    {title}
                </a>
            {:else}
                {title}
            {/if}
        </h3>
    {/if}
    <div use:fetchMore on:fetchmore={loadMorePosts}>
        <div class={'flex flex-col gap-8'}>
            {#each posts as post, index (post.id)}
                {#if index === posts.length - 3}
                    <div use:fetchMore on:fetchmore={loadMorePosts}>
                        <FeedPost {post} commentData={null} />
                    </div>
                {:else}
                    <FeedPost {post} commentData={null} />
                {/if}
            {/each}
        </div>
    </div>
    {#if $result.loading}
        <FeedPostLoader />
    {/if}
    {#if $result.errors}
        <div class={'alert alert-danger my-3'}>
            {$result.errors.map((e) => e.message).join('\n')}
        </div>
    {/if}
    {#if withButton && nbResults > maxPerPage}
        <div class={'flex justify-center my-6'}>
            <a href={fullPageUrl} class={'btn btn-lg btn-primary'}>
                {buttonLabel || 'Voir toutes nos actualités'}
            </a>
        </div>
    {/if}
</div>
